export default __webpack_public_path__ + "static/media/gogo.6de0de3e.png";